export default __webpack_public_path__ + "static/media/Eye.57fe92b0.svg";